import "./Services.css";
import {
  FaLaptopCode,
  FaShoppingCart,
  FaMobileAlt,
  FaServer,
  FaSearch,
  FaPaintBrush,
} from "react-icons/fa";

function Services() {
  const services = [
    {
      icon: <FaLaptopCode />,
      title: "Website Development",
      text: "Professional business, portfolio and corporate websites."
    },
    {
      icon: <FaShoppingCart />,
      title: "E-Commerce",
      text: "Online stores with payment gateway integration."
    },
    {
      icon: <FaMobileAlt />,
      title: "Mobile Responsive",
      text: "Fast and responsive websites for all devices."
    },
    {
      icon: <FaServer />,
      title: "Custom Software",
      text: "ERP, CRM and business management software."
    },
    {
      icon: <FaSearch />,
      title: "SEO Optimization",
      text: "Improve your Google ranking and online visibility."
    },
    {
      icon: <FaPaintBrush />,
      title: "UI / UX Design",
      text: "Modern and attractive user interface design."
    }
  ];

  return (
    <section className="services" id="services">

      <div className="container">

        <div className="section-title">

          <h5>OUR SERVICES</h5>

          <h2>Solutions We Offer</h2>

          <p>
            We provide complete digital solutions for startups,
            businesses and organizations.
          </p>

        </div>

        <div className="row g-4">

          {services.map((service, index) => (

            <div className="col-md-6 col-lg-4" key={index}>

              <div className="service-card">

                <div className="service-icon">

                  {service.icon}

                </div>

                <h4>{service.title}</h4>

                <p>{service.text}</p>

                <a href="#contact">

                  Read More →

                </a>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}

export default Services;